import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ChartFormatIndianNumber from "../../../Common/ChartFormatIndianNumber";
import NoDataFound from "../../NoDataFound/NoDataFound";
import useThemeTextColor from "../../../../../utils/useThemeTextColor";

const TotalRevenueChart = ({ chartData = [] }) => {
  const textColor = useThemeTextColor();
  const borderColor = useThemeTextColor("--why-choose-card-border");
  //  detect mobile
  const [isMobile,setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  const categories = chartData.map((item) => `${item.period}`);
  const grossSales = chartData.map((item) => item.gross);
  const netSales = chartData.map((item) => item.net);
  const actualNet = chartData.map((item) => item.actual_net);
  const adsSpend = chartData.map((item) => item.spend);

  const series = [
    { name: "Gross Sales", data: grossSales },
    { name: "Net Sales", data: netSales },
    { name: "Net Income", data: actualNet },
    { name: "Ads Spends", data: adsSpend },
  ];


  const formatNumber = (value) => {
    if (isMobile) {
      return `₹${ChartFormatIndianNumber(value)}`;
    }
    return `₹${value.toLocaleString("en-IN")}`;
  };

  const options = {
    chart: {
      type: "area",
      height: 350,
      toolbar: { show: false },
    },
    colors: ["#6C5CE7", "#007bff", "#28a745", "#ffc000"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.3,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories,
      labels: {
        rotate: -45,
        hideOverlappingLabels: true,
        style: { colors: textColor, fontSize: "12px" },
      },
      tickAmount: 8,
      axisBorder: { color: borderColor },
      axisTicks: { color: borderColor },
    },
    yaxis: {
      labels: {
        formatter: formatNumber,
        style: { colors: textColor, fontSize: "12px" },
      },
    },
    grid: { borderColor: borderColor, strokeDashArray: 3 },
    legend: {
      position: "bottom",
      labels: { colors: textColor },
      markers: { width: 12, height: 12, radius: 12 },
    },
    tooltip: {
      y: { formatter: formatNumber },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 300 },
          xaxis: {
            labels: { rotate: -60, style: { fontSize: "10px" } },
            tickAmount: 5,
          },
          legend: {
            position: "bottom",
            fontSize: "10px",
            markers: { width: 8, height: 8, radius: 8 },
          },
        },
      },
    ],
  };
 useEffect(() => {
   const handleResize = () => {
     setIsMobile(window.innerWidth < 768);
   };

   window.addEventListener("resize", handleResize);
   return () => window.removeEventListener("resize", handleResize);
 }, []);

  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }
  
  return (
    <div style={{ height: "360px" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={350}
      />
    </div>
  );
};

export default TotalRevenueChart;
